import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader } from './i18n-loader';

export function provideTranslocoScopeSharedFilter(): Provider {
  return provideTranslocoScope({ scope: 'filter', loader: i18nLoader });
}
